// extracted by extract-css-chunks-webpack-plugin
module.exports = {"checkbox":"lnFRg","error":"_13gUz"};